import { useSelector } from 'react-redux'

import { selectRole, selectUserData } from '../routing/fetchingfunction/user/user.reducer'

import { getProfileByRole, getUserName } from '../helpers'

const useUserName = () => {
  const userData = useSelector(selectUserData)
  const role = useSelector(selectRole)

  // Add defensive checks to handle null/undefined userData
  if (!userData) {
    console.warn('userData is null in useUserName hook')
    return '' // Return empty string as fallback
  }

  try {
    return getUserName(
      getProfileByRole(userData, role),
      userData.profile?.display_name,
      userData.profile?.display_last_name
    )
  } catch (error) {
    console.error('Error in useUserName hook:', error)
    return '' // Return empty string if anything fails
  }
}

export default useUserName
